import { colors } from "@indeed/ifl-tokens/react-native";
import React, { useMemo } from "react";
import { Platform, StyleSheet } from "react-native";

import { Box } from "../../../../../../mads";
import { Text } from "../../../../../../mads/Text";
import { useViewjobOneGraphModel } from "../../../../context/ViewJobDataContext";

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 16,
    paddingTop: 8,
    paddingBottom: Platform.OS === "web" ? 8 : 0,
  },
  text: { color: colors.neutral800 },
  simple: { color: colors.neutral700 },
});

export type DisclaimerViewJobButtonProps = {
  isSimpleVjImproveActive?: boolean;
  disclaimer?: string;
};

export function DisclaimerViewJobButton({
  isSimpleVjImproveActive,
  disclaimer,
}: DisclaimerViewJobButtonProps) {
  const textStyle = useMemo(
    () => ({ ...styles.text, ...(isSimpleVjImproveActive ? styles.simple : {}) }),
    [isSimpleVjImproveActive],
  );

  return (
    <Box sx={styles.container}>
      <Text sx={textStyle} level={1}>
        {disclaimer}
      </Text>
    </Box>
  );
}

export function OGWrappedDisclaimerViewJobButton() {
  const ogModel = useViewjobOneGraphModel();

  if (ogModel == null) {
    return null;
  }
  return (
    <DisclaimerViewJobButton
      isSimpleVjImproveActive={ogModel.features?.isSimpleVjImproveActive}
      disclaimer={ogModel.job?.viewJobDisclaimer}
    />
  );
}
